


















import RingLoader from './RingLoader.vue';
import Vue from 'vue'
import * as Sentry from '@sentry/vue';
import { customLogger } from '../../plugins/sentry/customLogger';
export default Vue.extend({
    name: 'AppLoader',
    props: {
        user: Object
    },
    components: {
        RingLoader,
    },
    computed: {
        enableAdvanceOption() {
            const enableReload = this.$store.state.loaderCount === 0 && (this.$store.state.locationLoaderActive || this.$store.state.agencyLoaderActive)
            if (enableReload) {
                customLogger({
                    message: 'Delayed_App_Load',
                    level: 'info',
                     tags: {
                        user_id: this.user?.id,
                        locationLoader: this.$store.state.locationLoaderActive,
                        agencyLoader: this.$store.state.agencyLoaderActive,
                        locationId: this.$route.params.location_id ?? ''
                    }
                })
            }
            return enableReload
        },
    },
    methods: {
        reload() {
            customLogger({message: 'forced_app_reload', level: 'info', tags: {
                user_id: this.user?.id,
                locationLoader: this.$store.state.locationLoaderActive,
                agencyLoader: this.$store.state.agencyLoaderActive,
                locationId: this.$route.params.location_id ?? ''
            }})
            localStorage.clear()
            localStorage.clear()
            sessionStorage.clear()
            document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
            window.location.reload()
        },
    },
})

